import styled from '@emotion/styled';
import { BaseButton, Variables } from '../../../base';

export const Container = styled.div`
    margin-left: 8px;
`;


export const ActionButton = styled(BaseButton)`
    min-width: auto;
    fill: ${Variables.ThemeLight.TextMild};
    height: 30px;
    width: 40px;
    border-color: transparent;
    background: none;
    svg {
        fill: ${Variables.ThemeLight.TextMild};
    }

    &:hover {
        fill: ${Variables.Colors.n70};
        background: white;
        border: solid 1px ${Variables.Colors.nx8};
    }

    padding: 0;
    z-index: 1;
`;